import { render, staticRenderFns } from "./AffiliateTestForm.vue?vue&type=template&id=61197d0f&scoped=true&"
import script from "./AffiliateTestForm.vue?vue&type=script&lang=js&"
export * from "./AffiliateTestForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61197d0f",
  null
  
)

export default component.exports